import Joi from 'joi';

const emptyString = Joi.string().empty('');

export const ImageVideoResourceComponentSchema = Joi.object({
    title: emptyString,
    description: Joi.any(),
    resourceImg1: Joi.object(),
    resourceImg2: Joi.object(),
    resourceImg3: Joi.object(),
    resourceImg4: Joi.object(),
    resourceImgAlt1: emptyString,
    resourceImgAlt2: emptyString,
    resourceImgAlt3: emptyString,
    resourceImgAlt4: emptyString,
    resourceTitle1: emptyString,
    resourceTitle2: emptyString,
    resourceTitle3: emptyString,
    resourceTitle4: emptyString,
    resourceDescription1: Joi.any(),
    resourceDescription2: Joi.any(),
    resourceDescription3: Joi.any(),
    resourceDescription4: Joi.any(),
    resourceLinkName1: emptyString,
    resourceLinkName2: emptyString,
    resourceLinkName3: emptyString,
    resourceLinkName4: emptyString,
    resourceUrl1: emptyString,
    resourceUrl2: emptyString,
    resourceUrl3: emptyString,
    resourceUrl4: emptyString,
    isResourceVideo1: Joi.boolean(),
    isResourceVideo2: Joi.boolean(),
    isResourceVideo3: Joi.boolean(),
    isResourceVideo4: Joi.boolean(),
}).options({ stripUnknown: true });